export default __webpack_public_path__ + "static/media/modulo-2.4d3bda2c.svg";